import { render, staticRenderFns } from "./body-card.vue?vue&type=template&id=c16a04f8&scoped=true&"
import script from "./body-card.vue?vue&type=script&lang=ts&"
export * from "./body-card.vue?vue&type=script&lang=ts&"
import style0 from "./body-card.vue?vue&type=style&index=0&id=c16a04f8&prod&lang=scss&"
import style1 from "./body-card.vue?vue&type=style&index=1&id=c16a04f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16a04f8",
  null
  
)

export default component.exports